import env from 'core/env'
export const PAGE_SIZE = env('VITE_PAGE_SIZE', 10)
export const AUTH_TOKEN = 'app/token'
export const AUTH_REFRESH = 'app/refresh'
export const AUTH_USER = 'state/user'
export const OPTIONAL_SETTING = 'optional/setting'
export const USER_MENU = 'state/menu'
export const USER_LANG = 'app/user/language'
export const MAP_STATE = 'map/state'
export const TABLE_STATE = 'table/state'
export const DATETIME_STATE = 'datetime/state'
export const CHART_STATE = 'chart/state'
export const COOKIE = 'cookie/viewer'
export const INFO_BANNER = 'info_banner/viewer'

export const SPECIAL_USER = 'probal@snapon.com'
export const SPECIAL_USER_PWD = 'SnapOn01'

